import type { Dayjs } from 'dayjs';

export type TaskModalValidationIssue = {
  code: string;
  message: string;
};

export function validateTaskModalEventDate(
  eventAt: Dayjs | null | undefined,
  message: string
): TaskModalValidationIssue | null {
  if (!eventAt || !eventAt.isValid()) {
    return { code: 'EVENT_DATE_REQUIRED', message };
  }
  return null;
}

export function validateTaskModalRequiredComment(
  comment: string | null | undefined,
  message: string
): TaskModalValidationIssue | null {
  if (!String(comment ?? '').trim()) {
    return { code: 'COMMENT_REQUIRED', message };
  }
  return null;
}

export function validateTaskModalRequiredText(
  value: string | null | undefined,
  code: string,
  message: string
): TaskModalValidationIssue | null {
  if (!String(value ?? '').trim()) {
    return { code, message };
  }
  return null;
}
